import { render, staticRenderFns } from "./DataFilesInput.vue?vue&type=template&id=34d71aef&"
import script from "./DataFilesInput.vue?vue&type=script&lang=js&"
export * from "./DataFilesInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports